import modal from "../../modules/modal/modal";
import VideoModalHandler from "../lib/VideoModalHandler";

let BUNDLE_BACK_URL = "http://127.0.0.1:8000/api/bundle";

BUNDLE_BACK_URL = "https://douglas.akqa.nz/api/bundle";

const AddGarnishToProductPage = (product) => {
  const bundlePage = "/collections/build-your-own-anti-anxious-station";

  // create a back link to /collections/
  const backLink = document.createElement("a");

  backLink.setAttribute("href", bundlePage);
  backLink.innerHTML = "Back to Bundle";
  backLink.classList.add("back-to-bundle");

  // add the back link as the first child product page
  const backContainer = document.createElement("div");
  backContainer.classList.add("back-to-bundle-container");
  backContainer.classList.add("container");
  backContainer.classList.add("container-xl");
  backContainer.appendChild(backLink);

  product.insertBefore(backContainer, product.firstChild);

  // hide the default .product-bar on the product page
  const productBar = document.querySelector(".product-bar");

  if (productBar) {
    productBar.style.display = "none";
  }

  // add the video block from the bundle page. Fetch the DOM from the bundle
  // page and insert it into the product page
  fetch(bundlePage).then((response) => {
    response.text().then((text) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const videoBlock = doc.querySelector(".text-image--has-video");

      if (videoBlock) {
        product.appendChild(videoBlock.closest(".shopify-section"));

        if (typeof window.lazy !== "undefined") {
          window.lazy.update();
        }

        if (typeof window.layzr !== "undefined") {
          window.layzr.update().check().handlers(true);
        }

        modal();
        VideoModalHandler();
      }

      // make sure bundle_me is in the url
      const params = new URLSearchParams(window.location.search);
      if (!params.has("bundle_me")) {
        params.append("bundle_me", "1");

        window.history.replaceState(
          {},
          "",
          `${location.pathname}?${params.toString()}`
        );
      }
    });
  });

  // handle the .product-options__item button. On click we need to add the product
  // to the bundle and take them back to the bundle page

  // check to see if product is out of stock
  const newAddToBundleButton = document.createElement("button");
  newAddToBundleButton.classList.add("bundle__product-add-btn");
  newAddToBundleButton.classList.add("btn");
  newAddToBundleButton.classList.add("btn--primary");

  if (product.dataset.available === "true") {
    newAddToBundleButton.innerHTML = "Add to Bundle";
  } else {
    newAddToBundleButton.innerHTML = "Out of Stock";
    newAddToBundleButton.setAttribute("disabled", "disabled");
    newAddToBundleButton.classList.add("btn--disabled");
  }

  const productForm = product.querySelector(".product-form");

  productForm.appendChild(newAddToBundleButton);
};

const bundle = () => {
  const root = document.querySelector("#bundle");
  let stored = localStorage.getItem("bundle");

  const params = new URLSearchParams(window.location.search);
  const productPage = document.querySelector("#new-product");

  if (productPage) {
    if (params.has("bundle_me")) {
      AddGarnishToProductPage(productPage);

      productPage.classList.add("bundle-product-page");
    } else {
      if (root) {
        // remove #bundle from the page
        root.parentNode.removeChild(root);
      }
    }
  }

  if (!root) {
    return;
  }

  if (params.has("preloadBundle")) {
    // preload the bundle with the product as given in the URL
    const sku = params.get("preloadBundle");

    // SKU will be in the format {quantity}@{variant_id}|{quantity}@{variant_id}
    // break this up and add each item to the cart
    const items = sku.split("|");
    const preloadedCart = [];

    items.forEach((item) => {
      let [quantity, variant_id] = item.split("@");
      let product = null;

      if (variant_id.indexOf("ID-") > -1) {
        variant_id = variant_id.replace("ID-", "");
        product = root.querySelector(`[data-variant-id="${variant_id}"]`);
      } else {
        product = root.querySelector(`[data-sku="${variant_id}"]`);
      }

      if (product) {
        // add the item to the cart
        preloadedCart.push({
          id: product.dataset.variantId,
          quantity: parseInt(quantity),
          title: product.dataset.title,
          unitPrice: product.dataset.unitPrice,
          sku: product.dataset.sku || "ID-" + product.dataset.variantId,
        });
      }
    });

    stored = JSON.stringify(preloadedCart);

    // remove preloadBundle from the url
    params.delete("preloadBundle");
    window.history.replaceState({}, "", `${location.pathname}`);
  }

  // eslint:disable-next-line
  window.BUNDLE_CART = [];
  let selectedDiscount = "0";

  const updateCart = (cart) => {
    window.BUNDLE_CART = cart;

    localStorage.setItem("bundle", JSON.stringify(cart));

    // update the totals used across the bar
    const fullPriceDOM = document.querySelector(".bundle__bar-full-price");
    const discountedPriceDOM = document.querySelector(".bundle__bar-total");

    // check to see if we have made the 15% threshold
    let totalItems = 0;
    let total = 0;
    let nextDiscountLevel = "";
    cart.forEach((item) => {
      totalItems += item.quantity;
      total += item.quantity * (item.unitPrice / 100);
    });

    if (totalItems > 3) {
      selectedDiscount = window.LEVEL_2_DISCOUNT;
      root.removeAttribute("data-discount-level-1");
      root.setAttribute("data-discount-level-2", "true");
    } else if (totalItems > 2) {
      selectedDiscount = window.LEVEL_1_DISCOUNT;
      root.setAttribute("data-discount-level-1", "true");
      root.removeAttribute("data-discount-level-2");
      let diff = 4 - totalItems;
      nextDiscountLevel =
        "Add " + diff + ` more ${diff == 1 ? "item" : "items"} for 20% off`;
    } else {
      selectedDiscount = "0";
      root.removeAttribute("data-discount-level-1");
      root.removeAttribute("data-discount-level-2");
      let diff = 3 - totalItems;
      nextDiscountLevel =
        "Add " +
        (3 - totalItems) +
        ` more ${diff == 1 ? "item" : "items"} for 15% off`;
    }

    document.querySelectorAll("[data-bundle-total-items]").forEach((el) => {
      if (totalItems == 1) {
        el.innerHTML = totalItems + " item";
      } else {
        el.innerHTML = totalItems + " items";
      }
    });

    const summaryDOM = document.querySelector(".bundle__bar-summary");

    if (summaryDOM && fullPriceDOM) {
      if (totalItems > 0) {
        fullPriceDOM.innerHTML = `$${total.toFixed(2).replace(/\.00$/, "")}`;
        discountedPriceDOM.innerHTML = `$${(
          total *
          (1 - selectedDiscount / 100)
        )
          .toFixed(2)
          .replace(/\.00$/, "")}`;

        // show the totals
        summaryDOM.style = "";
      } else {
        // hide the totals
        summaryDOM.style.display = "none";
      }

      if (selectedDiscount == "0") {
        fullPriceDOM.style.display = "none";
      } else {
        fullPriceDOM.style.display = "";
      }
    }

    // update all product .bundle__product-discounted with the discounted value
    // since that might have changed
    const discountedPrice = document.querySelectorAll(
      ".bundle__product-discounted"
    );

    discountedPrice.forEach((el) => {
      const price = parseFloat(el.dataset.price);
      let discountedPrice = (
        (price / 100) *
        (1 - selectedDiscount / 100)
      ).toFixed(2);

      // remove .00 from the end of the price
      discountedPrice = discountedPrice.replace(/\.00$/, "");

      el.innerHTML = `$${discountedPrice}`;
    });

    const upsellMessage = document.querySelector(
      "[data-bundle-upsell-message]"
    );

    if (upsellMessage) {
      if (nextDiscountLevel) {
        upsellMessage.innerHTML = nextDiscountLevel;
        upsellMessage.style.display = "block";
      } else {
        upsellMessage.style.display = "none";
      }
    }

    // if total items is > 2 then we can activate the button
    const checkoutBtn = document.querySelector(".bundle__bar-checkout-btn");
    if (checkoutBtn) {
      if (totalItems > 1) {
        checkoutBtn.removeAttribute("disabled");
        checkoutBtn.classList.remove("btn--disabled");
      } else {
        checkoutBtn.setAttribute("disabled", "disabled");
        checkoutBtn.classList.add("btn--disabled");
      }
    }
  };

  /**
   * Handle the submission. First we create the required variant id for this
   * custom bundle and then we add the new variant to the cart.
   */
  const checkoutBtn = document.querySelector(".bundle__bar-checkout-btn");

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", (e) => {
      if (checkoutBtn.hasAttribute("disabled")) {
        e.preventDefault();
        return;
      }

      // change button to loading state
      checkoutBtn.setAttribute("disabled", "disabled");
      checkoutBtn.innerHTML = "Adding to cart...";

      // POST request to our backend
      const bundlePayload = {
        products: window.BUNDLE_CART,
        discount: selectedDiscount,
        bundleContainerIds: window.BUNDLE_CONTAINER_IDS,
        price: document
          .querySelector(".bundle__bar-total")
          ?.innerHTML.replace("$", ""),
        compare_at: document
          .querySelector(".bundle__bar-full-price")
          ?.innerHTML.replace("$", ""),
      };

      fetch(BUNDLE_BACK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(bundlePayload),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data && data.error) {
            // show an error message
            checkoutBtn.innerHTML = "Error";
            console.error(data.error);
            return;
          }

          checkoutBtn.innerHTML = "Saving..";

          // add the variant to the cart
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Cache-Control": "no-cache",
            },
            body: JSON.stringify({
              items: [
                {
                  id: data.result.variant_id.replace(
                    "gid://shopify/ProductVariant/",
                    ""
                  ),
                  quantity: 1,
                },
              ],
            }),
          }).then((data) => {
            try {
              // clear the bundle that we have built
              localStorage.removeItem("bundle");
            } catch (e) {
              console.error(e);
            }

            // reload the same page with the #cart anchor so the user can see the cart
            let currentURL = window.location.href.split("#")[0];
            checkoutBtn.innerHTML = "Loading cart..";
            window.location.href = currentURL + "#cart";

            setTimeout(function () {
              window.location.reload();
            }, 5000);
          });
        });
    });
  }

  if (stored) {
    let bundleCart = JSON.parse(stored);

    try {
      let invalidItems = [];

      // for all the products already in the cart show the correct quantity
      bundleCart.forEach((item) => {
        const product = root.querySelector(`[data-variant-id="${item.id}"]`);

        if (!product) {
          // remove the item from the cart
          invalidItems.push(item);
          return;
        }

        product.classList.add("is-added");
        const quantity = product.querySelector(
          ".bundle__product-quantity-value"
        );

        if (quantity) {
          quantity.innerHTML = item.quantity;
        }
      });
      updateCart(bundleCart);
    } catch (e) {
      console.error(e);
      bundleCart = [];

      updateCart(bundleCart);
    }
  } else {
    let bundleCart = [];

    updateCart(bundleCart);
  }

  // add handler for each bundle__product-add-btn button so when clicked it adds the product to the bundle cart
  const addBtns = document.querySelectorAll(".bundle__product-add-btn");

  addBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      let product = e.target.closest(".bundle__product");
      let isProductPage = false;

      if (!product) {
        // look for a parent
        product = document.querySelector("#new-product");
        isProductPage = true;
      }

      const id = product.dataset.variantId;

      const existing = window.BUNDLE_CART.find((item) => item.id == id);
      let cart = window.BUNDLE_CART;
      // check to see if the product is already in the cart
      if (!existing) {
        // add the item to the cart
        cart.push({
          id,
          quantity: 1,
          title: product.dataset.title,
          unitPrice: product.dataset.unitPrice,
          sku: product.dataset.sku || "ID-" + id,
        });
      } else {
        cart = cart.map((item) => {
          if (item.id === id) {
            item.quantity += 1;
          }

          return item;
        });
      }

      // update the quantity value
      const qty = product.querySelector(".bundle__product-quantity-value");

      if (qty) {
        qty.innerHTML = 1;
      }

      // save the updated cart
      updateCart(cart);

      // update the UI
      product.classList.add("is-added");

      // reload the page
      if (isProductPage) {
        // reload the page with the bundle_me parameter
        window.location.reload();
      }

      return false;
    });
  });

  // add handler for the bundle__product-subtract button so when clicked it removes the product from the bundle cart
  // or reduces the quantity
  const subtractBtns = root.querySelectorAll(".bundle__product-subtract");

  subtractBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const product = e.target.closest(".bundle__product");
      const id = product.dataset.variantId.toString();

      // remove the item from the cart
      let isProductRemoved = false;

      const updatedCart = window.BUNDLE_CART.map((item) => {
        let result = Object.assign({}, item);

        if (result.id == id) {
          result.quantity -= 1;

          if (result.quantity === 0) {
            isProductRemoved = true;
          }
        }

        return result;
      }).filter((item) => item && item.quantity > 0);

      updateCart(updatedCart);

      // update the UI
      if (isProductRemoved) {
        product.classList.remove("is-added");
        product.querySelector(".bundle__product-quantity-value").innerHTML = 0;
      } else {
        product.querySelector(".bundle__product-quantity-value").innerHTML =
          updatedCart.find((item) => item.id == id).quantity;
      }

      return false;
    });
  });

  // add handler for bundle__product-add button so when clicked it increments the quantity
  const addQuantityBtns = root.querySelectorAll(
    ".bundle__product-quantity .bundle__product-add"
  );

  addQuantityBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const product = e.target.closest(".bundle__product");
      const id = product.dataset.variantId;

      // add the item to the cart
      let bundleCart = window.BUNDLE_CART.map((item) => {
        if (item.id === id) {
          item.quantity += 1;
        }

        return item;
      });

      updateCart(bundleCart);

      // update the UI
      product.querySelector(".bundle__product-quantity-value").innerHTML =
        bundleCart.find((item) => item.id === id).quantity;

      return false;
    });
  });
};

export default bundle;
